﻿import jquery from 'jquery';
import functions from './functions';
var HabEvents = require('../../Global/habitaclia-events');

class Footer {
    constructor(mortgageLead) {
        var self = this;
        this._mortgageLead = mortgageLead;
        this.registerEvents(self);
    }
   

    registerEvents(self) {
        jquery('#js-recomendar').click((e) => {
            e.preventDefault();
            const url = e.currentTarget.getAttribute('href');
            functions.CreateWindow(url, 800, 500);
        });

        this.__$calcHipoteca = jquery('.js-footer-calc-hipoteca');

        this.__$calcHipoteca.on('click touchstart', function () {

            var mortgageLead = {
                name: self._mortgageLead.Name,
                email: self._mortgageLead.Email,
                phone: self._mortgageLead.Phone,
                provinceCode: self._mortgageLead.ProvinceCode,
                propertyPrice: self._mortgageLead.PropertyPrice,
                device: self._mortgageLead.Device,
                userid: self._mortgageLead.UserId
            };

            var request = jquery.ajax({
                type: 'POST',
                url: self._mortgageLead.UrlApiMortgage,
                data: mortgageLead
            });

            request.done(function (data) {
                if (data && data.href) {
                    location.href = data.href;
                } else {
                    location.href = self._mortgageLead.DefaultHref;
                }
            });

            request.fail(function () {
                location.href = self._mortgageLead.DefaultHref;
            });

            jquery.publish(HabEvents.EventsEnum.ClickCalcHipoteca, ['footer']);
        });

    }
}

if (typeof module !== 'undefined' && module.exports) {
    /*jshint undef: false*/
    module.exports = new Footer(MortgageLeadDTOFooter);
} else {
    /* jshint unused: false */
    const footerInstance = new Footer(MortgageLeadDTOFooter);
}